import { Loader, Stack } from "@mantine/core";
import { useState } from "react";

export const ScribePage = (props: { src: string }) => {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <Stack h="100%" w="100%" gap={0} bg="rgba(228, 232, 238, 0.2)">
            {isLoading && <Loader pos="relative" top="50%" h={0} />}

            <iframe
                src={props.src}
                width="100%"
                height="100%"
                allow="fullscreen"
                style={{ border: 0, minHeight: 640 }}
                onLoad={() => setIsLoading(false)}
            />
        </Stack>
    );
};
